import { ref, onBeforeUnmount } from 'vue';
import { Shopflow, EVENTS, PLUGIN_EVENTS, type BatteryInfo } from './index';

const removeListener = ref<(() => void) | null>(null);

export const useBattery = () => {
  const unsubscribeCallback = ref<(() => void) | null>(null);

  const start = async () => {
    if (removeListener.value) {
      return;
    }

    const { remove } = await Shopflow.addListener(PLUGIN_EVENTS.BATTERY_LEVEL_CHANGE, event => {
      dispatchEvent(new CustomEvent(EVENTS.BATTERY_LEVEL_CHANGE, { detail: event }));
    });

    removeListener.value = remove;
    Shopflow.startBatteryTracking();
  }

  const stop = async () => {
    Shopflow.stopBatteryTracking();

    if (removeListener.value) {
      removeListener.value();
      removeListener.value = null;
    }

    unsubscribe();
  }

  const subscribe = (callback: (batteryLevel: number) => void) => {
    unsubscribe();

    const listener = (event: CustomEvent<BatteryInfo>) => {
      callback(event.detail.batteryLevel);
    }

    window.addEventListener(EVENTS.BATTERY_LEVEL_CHANGE, listener);

    unsubscribeCallback.value = () => {
      window.removeEventListener(EVENTS.BATTERY_LEVEL_CHANGE, listener);
    }
  }

  const unsubscribe = () => {
    if (unsubscribeCallback.value) {
      unsubscribeCallback.value();
      unsubscribeCallback.value = null;
    }
  }

  onBeforeUnmount(unsubscribe);

  return {
    start,
    stop,
    subscribe,
    unsubscribe
  }
}